<template>
  <div class="container-fluid">
    <transition :css="false">
    <el-dialog title="Add Email" :visible.sync="showModal" width="40%">
      <form>
            <p v-show="errorGroup" class="text-danger text-center font-weight-bold">Group Name and Email Addresses are required!</p>

        <arnergy-dynamic
            v-model="form.groupID"
            label="Select Group"
            :items="groups"
            @subgroup="getSubgroupss"
          />
        <div v-show="form.groupID" class="form-check ml-2">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            v-model="form.status"
            id="defaultCheck1"
          />
          <label class="form-check-label" for="defaultCheck1">
            Do you want to add Subgroup to Email ?
          </label>
        </div>
        <br />
        <div v-show="form.status">
          <arnergy-select
            v-model="form.subgroup"
            label="Subgroup"
            :items="subgroups"
          />
        </div>
        <div class="d-flex justify-content align-items-center">
          <input
            type="email"
            v-model="email"
            style="width: 100%; height: 4rem;"
          />
          <button
            class="btn btn-primary"
            @click="addField"
            style="height: 4rem;"
          >
            Add Email
          </button>
        </div>

        <br />
        <div>
          <p v-show="emailAddress">Email Address Selected</p>
          <div class="">
            <div v-for="item in emailAddress" :key="item.email">
              <div class="d-flex justify-content-between">
                <div class="pb-3">{{ item.email }}</div>
                <div class="text-danger" @click="removeField(item.email)"      style="cursor: pointer"
>Remove</div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <hr />

         <div class="d-flex justify-content align-items-center">
          <input
            type="email"
            v-model="emailCC"
            style="width: 100%; height: 4rem;"
          />
          <button
            class="btn btn-primary"
            @click="addFieldCC"
            style="height: 4rem;"
          >
            Add EmailCC
          </button>
        </div>

        <br />
        <div>
          <p v-show="emailAddressCC">EmailCC Address Selected</p>
          <div class="">
            <div v-for="item in emailAddressCC" :key="item.emailCC">
              <div class="d-flex justify-content-between">
                <div class="pb-3">{{ item.email }}</div>
                <div class="text-danger" @click="removeFieldCC(item.email)" style="cursor: pointer">Remove</div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <hr />

         <div class="d-flex justify-content align-items-center">
          <input
            type="email"
            v-model="emailBCC"
            style="width: 100%; height: 4rem;"
          />
          <button
            class="btn btn-primary"
            @click="addFieldBCC"
            style="height: 4rem;"
          >
            Add Email BCC
          </button>
        </div>

        <br />
        <div>
          <p v-show="emailAddressBCC">EmailBCC Address Selected</p>
          <div class="">
            <div v-for="item in emailAddressBCC" :key="item.emailBCC">
              <div class="d-flex justify-content-between">
                <div class="pb-3">{{ item.email }}</div>
                <div class="text-danger" @click="removeFieldBCC(item.email)" style="cursor: pointer">Remove</div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <hr />


       
            <div class="pt-4 text-right">
            <div v-if="loader" className="text-center">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
                        <button class="btn btn-primary" @click="emailFunc">Submit</button>

          </div>
          </div>
      </form>
    </el-dialog>
    </transition>

    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>New User</h3>
        <hr />
      </div>
    </vk-offcanvas>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Email</h2>
        <can I="create" a="user">
          <span style="display: flex; align-items: center;">
            <button
              class="btn btn-primary"
              to="/user/new"
              @click="showModal = true"
            >
              New Email
            </button>
          </span>
        </can>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <Users />
            </can>
            <el-tabs v-model="activeTab">
              <!-- <can I="read" a="user">
                <el-tab-pane label="User List" name="user_list">
                  <Users/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="device">
                <el-tab-pane label="User Devices" name="user_devices">
                  <Devices/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="wallet">
                <el-tab-pane label="Transaction History" name="transaction_history">
                  <transaction-histories/>
                </el-tab-pane>
              </can>-->
              <!-- <can I='read' a='user'>
                  <el-tab-pane title="User Role Management">
                  <user-role/>
                  </el-tab-pane>
              </can>-->
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Users from "../user-mgt/EmailInfo";
import Devices from "../devices/List";
import transactionHistories from "../shs/Wallet";
import userRole from "../users/allow";
import { mapGetters } from "vuex";
import ModalMain from "../kitchen/Onboarding/ModalMain.vue";
import ArnergyInput from "../kitchen/ArnergyInput.vue";
import ArnergySelect from "../kitchen/ArnergySelect.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import ArnergyDynamic from "../kitchen/AnergySelectDynamic.vue";


import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  Dialog,
  RadioGroup,
  RadioButton,
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import VueSweetalert2 from "vue-sweetalert2";
import Vue from "vue";
import "sweetalert2/dist/sweetalert2.min.css";

export default {
  name: "",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    "el-dialog": Dialog,
    Users,
    ArnergyDynamic,
    Multiselect,
    Devices,
    transactionHistories,
    VueSweetalert2,
    userRole,
    ArnergyInput,
    ArnergySelect,
    ModalMain,
  },
  data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      showModal: false,
      emailAddress: [],
      emailAddressCC: [],
      emailAddressBCC: [],
      errorGroup: false,
      loader: false,
      email: "",
      emailCC: "",
      emailBCC: "",
      form: {
        name: "",
        groupID: "",
        description: "",
        status: false,
      },
       groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      formErrors: {
        name: "",
        description: "",
      },
      value: [],
      options: [
        { name: "Vue.js", language: "JavaScript" },
        { name: "Adonis", language: "JavaScript" },
        { name: "Rails", language: "Ruby" },
        { name: "Sinatra", language: "Ruby" },
        { name: "Laravel", language: "PHP" },
        { name: "Phoenix", language: "Elixir" },
      ],
    };
  },
  computed: {
     ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getEmails",
      "getGroups",
      "getSubgroups",
      "getDummy",
      "getDevices",
    ]),
  },
  methods: {
    handleClose() {
      this.showModal = false;
    },
    addField(e) {
      e.preventDefault();
      if (this.email) {
        this.emailAddress.push({ email: this.email });
        this.email = "";
      }
      console.log(this.emailAddress);
    },
     addFieldCC(e) {
      e.preventDefault();
      if (this.emailCC) {
        this.emailAddressCC.push({ email: this.emailCC });
        this.emailCC = "";
      }
      console.log(this.emailAddress);
    },
     addFieldBCC(e) {
      e.preventDefault();
      if (this.emailBCC) {
        this.emailAddressBCC.push({ email: this.emailBCC });
        this.emailBCC = "";
      }
      console.log(this.emailAddress);
    },
    emailFunc(e) {
      e.preventDefault();
      const HTTP = this.$httpUtils.instance;
      const data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        emailAddress: {
          emailTo: this.emailAddress,
          emailCc:this.emailAddressCC,
          emailBcc: this.emailAddressBCC
        },
      };
      console.log(data);
      if(data.groupid && data.emailAddress){
        this.loader =  true;
      HTTP.post("/emailsetups/addEmail", data)
        .then((res) => {
          if (res.data) {
            this.showModal = false;
            this.showAlert();
            this.loader = false;
            this.fetchEmails();
            this.form.groupID ="";
            this.form.subgroup ="";
            this.emailAddress.emailTo = "";
            this.emailAddress.EmailCC = "";
            THIS.emailAddress.emailBCC ="";
          }
        })
        .catch((err) => {
          console.log(err);
        });
      }
      else{
        this.errorGroup = true;
        setTimeout(() => this.errorGroup = false, 1500);

      }
    },
     removeField(email) {
      if (email) {
        this.emailAddress.splice(
          this.emailAddress.findIndex((e) => e.email === email),
          1,
        )
      }
      console.log(this.phoneNumbers)
    },
     removeFieldCC(email) {
      if (email) {
        this.emailAddressCC.splice(
          this.emailAddressCC.findIndex((e) => e.email === email),
          1,
        )
      }
      console.log(this.phoneNumbers)
    },
     removeFieldBCC(email) {
      if (email) {
        this.emailAddressBCC.splice(
          this.emailAddressBCC.findIndex((e) => e.email === email),
          1,
        )
      }
      console.log(this.phoneNumbers)
    },
        async getSubgroupss(id) {
      const HTTP = this.$httpUtils.instance;
      let formData = new FormData();
      formData.append("groupid", id);
      let res = await HTTP.post(
        "/customerSubGroups/getCustomerSubGroupByGroupId",
        formData
      )
        .then((res) => {
          this.subgroups = res.data
            .map((item) => {
              return {
                id: item.id,
                name: item.subgroupname,
              };
            })
            .sort((a, b) => {
              return a.name > b.name ? 1 : -1;
            });
        })
        .catch((e) => {
          //
        });
      // parse for "arnergy-select" us
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "Email Set up Successfully",
        icon: "success",
        width: "550px",
      });
    },
    fetchEmails() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/emailsetups/getEmailSetupDetail
`;
      HTTP.post(url)
        .then((response) => {
          const list = response.data;
          this.$store.commit("saveEmails",  list.map((data) => ({
            id: data.id,
            groupname: data.groupname,
            subgroupname: data.subgroupname,
            emailaddress: data.emailaddress,
            sendtype: data.sendtype,

            status: data.status === 0 ? "Disabled" : "Enabled"
          })));

          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
   async mounted() {
    this.groups = this.getGroups
      .map((item) => {
        return {
          id: item.id,
          name: item.groupname,
        };
      })
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });

    this.subgroups = this.getSubgroups
      .map((item) => {
        return {
          id: item.id,
          name: item.subgroupname,
        };
      })
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
  },
};
</script>

<style lang="scss" scoped>
.close-btn {
  color: orangered;
  font-size: 16px;
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/Email.vue